import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import CommonPopup from "@components/common/popup/CommonPopup";
import DashBoardPops from "@components/common/popup/pops/DashBoardPops";
import Logout from "@components/login/Logout";
import DashBoardHeader from "@layout/header/dashBoard/DashBoardHeader";
import MyAccount from "@layout/header/dashBoard/MyAccount";
import { adminTabState, adminTypeState, checkTypeState, curAdminTreeState, curMonitoringTreeState, curReportState, curSchduleTreeState, deviceState, energySolutoinHistory, noneUrl, reportTypeState, todayState, } from "@recoil/assessmentState";
import { checkSheetState, contactusState, loadingBoxDarkState, loadingBoxState, menuListState, parentCode, urlState, } from "@recoil/menuState";
import { URL_LOGIN, URL_NOT_FOUND, URL_SEI } from "@utils/Const";
import { useCallback, useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate, useNavigationType } from "react-router-dom";
import { useRecoilState, useRecoilValue, useResetRecoilState, useSetRecoilState } from "recoil";
export const DashBoardLayout = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const navigationType = useNavigationType();
    const loading = useRecoilValue(loadingBoxState);
    const loadingDark = useRecoilValue(loadingBoxDarkState);
    useEffect(() => {
        if (URL_SEI !== location.pathname) {
            navigate(location.pathname, { replace: true });
        }
        if (navigationType === "POP") {
            resetReport();
        }
    }, [location.pathname]);
    // recoil
    const [urlInfo, setRecoilUrlInfo] = useRecoilState(urlState);
    const [menuRecoilList, setRecoilMenuList] = useRecoilState(menuListState);
    const [checkReport, setCheckReport] = useRecoilState(reportTypeState);
    const recoilNoneUrlInfo = useRecoilValue(noneUrl);
    const check = useRecoilValue(checkTypeState);
    const report = useRecoilValue(reportTypeState);
    //초기화
    const resetCheckSheet = useResetRecoilState(checkSheetState);
    const resetRecoilTreeData = useResetRecoilState(curSchduleTreeState);
    const resetRecoilData = useResetRecoilState(curMonitoringTreeState);
    const resetRecoilAdminData = useResetRecoilState(curAdminTreeState);
    const resetCheck = useResetRecoilState(checkTypeState);
    const resetRecoilReportData = useResetRecoilState(curReportState);
    const resetRecoilToday = useResetRecoilState(todayState);
    const resetDeviceInfo = useResetRecoilState(deviceState);
    const resetRecoilAdminType = useResetRecoilState(adminTypeState);
    const resetRecoilContactusState = useResetRecoilState(contactusState);
    const resetRecoilEnergyHistory = useResetRecoilState(energySolutoinHistory);
    const resetReport = useResetRecoilState(reportTypeState);
    const resetRecoilTab = useResetRecoilState(adminTabState);
    const setMenuCodeRecoil = useSetRecoilState(parentCode);
    const [menuList, setMenuList] = useState(null);
    useEffect(() => {
        setRecoilUrlInfo(location.pathname);
    }, [location.pathname]);
    // 특정 화면에서 url로 menu 정보 추출하기 위함
    useEffect(() => {
        let tmenuList = menuRecoilList;
        if (tmenuList.length <= 0) {
        }
        let curMenu = null;
        tmenuList
            .filter((smenu) => smenu.url === urlInfo)
            .map((smenu) => {
            if (smenu.url === urlInfo)
                curMenu = smenu;
        });
        setMenuCodeRecoil(curMenu && curMenu.parentCode);
        const tempMenu = [];
        tmenuList
            .filter((smenu) => curMenu && smenu.parentCode === curMenu.parentCode)
            .map((smenu) => {
            tempMenu.push({
                menuName: smenu.menuName,
                menuUrl: smenu.url,
            });
        });
        setMenuList(tmenuList);
        if (!recoilNoneUrlInfo) {
            // 초기화
            resetCheckSheet();
            resetRecoilData();
            resetRecoilTreeData();
            resetRecoilAdminData();
            resetCheck();
            resetRecoilReportData();
            resetRecoilToday();
            resetDeviceInfo();
            resetRecoilAdminType();
            resetRecoilContactusState();
            resetRecoilEnergyHistory();
            resetRecoilTab();
            // resetRecoilEnergyTab();
            setCheckReport(Object.assign(Object.assign({}, checkReport), { smenu: "enable" }));
            window.scrollTo({ top: 0 });
        }
        if (menuRecoilList != null && menuRecoilList.length != 0 && !menuRecoilList.some((menu) => menu.url === urlInfo)) {
            navigate(URL_NOT_FOUND, { replace: true });
        }
    }, [urlInfo, menuRecoilList]);
    useEffect(() => {
        const handleClick = (e) => {
            const targetElement = e.target;
            const isSelect = targetElement.classList.contains("select") || targetElement.closest(".select");
            if (isSelect) {
                return;
            }
            const allSelectBoxElements = document.querySelectorAll(".select");
            allSelectBoxElements.forEach((boxElement) => {
                boxElement.classList.remove("active");
            });
        };
        window.addEventListener("click", handleClick);
        return () => window.removeEventListener("click", handleClick);
    }, []);
    const [popData, setPopData] = useState([]);
    const handleOpenPop = useCallback((id, body) => {
        setPopData((prev) => [...prev, { id, body }]);
    }, []);
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ id: "wrap", className: `${check.checkOn || report.checkType == "view" ? "float-page" : ""} 
        ${report.checkType == "proposal" ? "float-page type2" : ""}
        ${check.checkOn && check.nextStep !== "checkList" && check.nextStep !== "result" ? "onepage" : ""}` }, { children: [!check.checkOn && _jsx(DashBoardHeader, {}), menuList && urlInfo && _jsx(Outlet, { context: { handleOpenPop } })] })), _jsx(Logout, { path: URL_LOGIN }), _jsx(MyAccount, {}), _jsx(DashBoardPops, { popData: popData }), _jsx(CommonPopup, {}), _jsx("div", { className: "dimm" }), loading && _jsx(Loading, {}), loadingDark && _jsx(LoadingDark, {})] }));
};
function Loading(props) {
    const loadingBox = useRecoilValue(loadingBoxState);
    const isAuth = props.isAuth;
    return (_jsx(_Fragment, { children: _jsx("div", Object.assign({ className: !isAuth || loadingBox ? "loading" : "" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB85C\uB529\uC911" })) })) }));
}
function LoadingDark(props) {
    const loadingBoxDark = useRecoilValue(loadingBoxDarkState);
    const isAuth = props.isAuth;
    return (_jsx(_Fragment, { children: _jsx("div", Object.assign({ className: !isAuth || loadingBoxDark ? "loading bg-gary" : "" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB85C\uB529\uC911" })) })) }));
}
